<template>
  <van-action-sheet 
    v-model="show" 
    :title="day"
    :safe-area-inset-bottom="false"
    class="action"
  >
    <div class="main">
      <!-- 上午 -->
      <div class="box am" v-if="amData.length">
        <span>上午</span>
        <div class="time">
          <div class="wrap" v-for="(item, index) in amData" :key="index">
            <div :class="['item', {current: index == n1}]" @click="pick(index, 'am')">
              <!-- <span :class="{text: !item.remainNum}">{{ item.timeSlot }}</span>
              <van-tag plain type="success" :class="{tag: !item.remainNum}">
                {{ item.remainNum ? '预约' : '约满' }}
              </van-tag> -->
              <div :class="{text: !item.remainNum}" class="timeDate">{{ item.timeSlot }}</div>
              <div :class="{tag: !item.remainNum, yesNum:item.remainNum}" class="num">
                {{ item.remainNum ? '剩余号源'+item.remainNum : '约满' }}
              </div>
            </div>
            <div class="mask" v-if="!item.remainNum"></div>
          </div>
        </div>
      </div>
      <!-- 下午 -->
      <div class="box pm" v-if="pmData.length">
        <span>下午</span>
        <div class="time">
          <div class="wrap" v-for="(item, index) in pmData" :key="index">
            <div :class="['item', {current: index == n2}]" @click="pick(index, 'pm')">
              <!-- <span :class="{text: !item.remainNum}">{{ item.timeSlot }}</span> -->
              <!-- <van-tag plain type="success" :class="{tag: !item.remainNum}">
                {{ item.remainNum ? '预约' : '约满' }}
              </van-tag> -->
              <div :class="{text: !item.remainNum}" class="timeDate">{{ item.timeSlot }}</div>
              <div :class="{tag: !item.remainNum, yesNum:item.remainNum}" class="num">
                {{ item.remainNum ? '剩余号源'+item.remainNum : '约满' }}
              </div>
            </div>
            <div class="mask" v-if="!item.remainNum"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="my-button">
        <van-button type="info" round @click="confirm" :disabled="!data">
          提交订单
        </van-button>
      </div>
  </van-action-sheet>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { subscribe, validateNotImm } from 'api/appointment'

export default {
  data() {
    return {
      show: false,
      day: '',
      amData: [],
      pmData: [],
      n1: -1,
      n2: -1,
      data: null
    }
  },
  computed: {
    ...mapState(['params', 'vacc'])
  },
  watch: {
    show(value) {
      if (!value) {
        this.n1 = -1
        this.n2 = -1
        this.data = null
      }
    }
  },
  methods: {
    // 提交订单
    confirm() {
      if (!this.data) {
        return this.$toast('请选择接种时间段')
      }
      // 非免规苗订单校验
      if (this.vacc.notImmunizationPlanning) {
        const data = {
          profileCode: this.params.profileCode,
          vaccineSupId: this.vacc.vaccineSupId,
          reservationDate: this.day,
          reservationTime: this.data.timeSlot
        }
        validateNotImm(data).then(res => {
          if (res.code != 0) {
            this.$toast(res.message)
          } else {
            this.appointment()
          }
        })
      } else {
        this.appointment()
      }
    },
    // 下单
    appointment() {
      const pickDate = this.day + ' ' + this.data.timeSlot.substr(6)
      if (moment(pickDate, 'YYYY-MM-DD HH:mm:ss').valueOf() < moment().valueOf()) {
        return this.$toast('已超过该时间段，无法预约')
      }
      const data = {
        ...this.params,
        reservationDate: this.day,
        reservationTime: this.data.timeSlot
      }
      subscribe(data).then(res => {
        this.show = false
        if (res.code != 0) {
          return this.$toast(res.message)
        }
        this.$router.push({
          path: '/success',
          query: {
            reservationDate: data.reservationDate,
            reservationTime: data.reservationTime
          }
        })
      })
    },
    // 选中
    pick(index, type) {
      if (type == 'am') {
        if (index == this.n1) return
        this.n1 = index
        this.n2 = -1
        this.data = this.amData[index]
      } else {
        if (index == this.n2) return
        this.n2 = index
        this.n1 = -1
        this.data = this.pmData[index]
      }
    },
    open(day, data) {
      this.show = true
      this.day = day
      // 时间段数据处理
      const noon = moment('12:00', 'HH:mm').valueOf()
      this.amData = data.filter(v => {
        return moment(v.timeSlot.substr(6), 'HH:mm').valueOf() <= noon
      })
      this.pmData = data.filter(v => {
        return moment(v.timeSlot.substr(0,5), 'HH:mm').valueOf() > noon
      })
    }
  }
}
</script>

<style lang="less" scoped>
.action {
  height: 80%;
}
.main {
  padding: 0 13px 85px 13px;
  .box {
    margin-bottom: 11px;
    span {
      font-weight: 500;
      opacity: .85;
    }
    .time {
      margin-top: 11px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .wrap {
        width: 48%;
        position: relative;
        .num{
          border-top:1px solid #ddd;
          padding:5px 0px;
        }
        .timeDate{
          padding: 3px 0px;
          transform: translateY(-4px);
        }
        .item {
          height: 41px;
          border: 1px solid #ddd;
          border-radius: 5px;
          padding: 10px 0px;
          text-align: center;
          // display: flex;
          // justify-content: space-between;
          // align-items: center;
          margin-bottom: 11px;
          .yesNum {
            color:var(--blue) !important
          }
          .text {
            color: #999;
          }
          // .tag {
          //   background: #fff;
          //   border-color: #999;
          //   color: #999;
          // }
          .tag{
            //  background: #fff;
            border-color: #ddd;
            color: #fff;
            background:#ddd;
          }
        }
        .current {
          border-color: var(--blue) !important;
        }
        .mask {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 62px;
          border-radius: 5px;
          background: rgba(0,0,0,.05);
        }
      }
    }
  }
}
.my-button {
  background: #fff !important;
}
</style>